/* Copyright 2013 - 2024 Waiterio LLC */
/* eslint-disable no-new-func */

export default new Function(
  'try {return this===global;}catch(e){return false;}',
)()
